interface LiveChatSDK {
  open: () => void;
  close: () => void;
  toggle: (forceState?: boolean) => void;
  isOpen: () => boolean;
}

const LIVE_CHAT_SCRIPT_ID = "ai-live-chat-next-script";
const LIVE_CHAT_LOCAL_URL = "http://10.10.10.11:8889";
const LIVE_CHAT_CDN_URL = "https://static.crazysales.com.au/shop-helper-kit";

export function loadAiLiveChat(useLocalLoader = false) {
  if (typeof window === "undefined") return;
  if (document.getElementById(LIVE_CHAT_SCRIPT_ID)) return;

  const cacheBuster = Date.now().toString();
  const apiEnv =
    useLocalLoader
      ? "test"
      : "production";
  const scriptBaseUrl = useLocalLoader
    ? LIVE_CHAT_LOCAL_URL
    : LIVE_CHAT_CDN_URL;
  const widgetSrc = `${scriptBaseUrl}/widget/live-chat-widget.js?_t=${cacheBuster}`;
  const params = new URLSearchParams({
    site: "crazysales",
    apiEnv,
    width: "440px",
    height: "100vh",
    top: "0",
    right: "0",
    hideButton: "false",
    _t: cacheBuster,
    widgetSrc,
  });
  const src = `${scriptBaseUrl}/live-chat-next.js?${params.toString()}`;

  const script = document.createElement("script");
  script.id = LIVE_CHAT_SCRIPT_ID;
  script.src = src;
  script.async = true;
  script.onerror = (error) => {
    script.remove();
    console.error("[live-chat] Script injection failed:", src, error);
  };

  document.head.appendChild(script);
}

declare global {
  interface Window {
    LiveChatSDK?: LiveChatSDK;
  }
}

function runWithLiveChatSDK(action: (sdk: LiveChatSDK) => void) {
  if (typeof window === "undefined") return;

  if (window.LiveChatSDK) {
    action(window.LiveChatSDK);
    return;
  }

  window.addEventListener(
    "live-chat-ready",
    () => {
      if (window.LiveChatSDK) action(window.LiveChatSDK);
    },
    { once: true },
  );
}

export function openLiveChat() {
  runWithLiveChatSDK((sdk) => sdk.open());
}

export function closeLiveChat() {
  runWithLiveChatSDK((sdk) => sdk.close());
}

export function toggleLiveChat(forceState?: boolean) {
  runWithLiveChatSDK((sdk) => sdk.toggle(forceState));
}

export function isLiveChatOpen() {
  if (typeof window === "undefined") return false;

  return window.LiveChatSDK?.isOpen() ?? false;
}
